import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useDataContext } from 'context/DataStoreContext';
import { useAuth } from 'model/Auth';
import { User } from 'model/User';
import { hasPermission } from 'model/Route';
import { generalStyle } from 'helper/Style';
import { convertUserName } from 'helper/Converter';
import Layout from 'component/part/Layout';
import BackLink from 'component/part/BackLink';
import H2 from 'component/part/H2';
import List, { ListIndex } from 'component/part/List';

const userConditions = { with: ['role'] };

const getUserIndexes = (displaySensitive: boolean): ListIndex[] => [
  { label: '氏名', key: 'lastName' },
  { label: '役職', key: 'roleId' },
  ...(displaySensitive
    ? [
      { label: '日給', align: 'right' as const },
      { label: 'ユーザー名', key: 'accountName' },
      { label: 'メールアドレス', key: 'email' },
    ]
    : []
  ),
];

type UserAttribute = User & {
  displayEmail: User['email'] | null;
  displayAccountName: User['accountName'] | null;
};

const MemberList: React.FC = () => {
  const { state } = useDataContext();
  const { list = [] } = state?.user || {};
  const { user: owner } = useAuth();
  const enableEdit = owner && hasPermission('member', 'edit', owner.role);
  const [users, setUsers] = useState<UserAttribute[]>([]);
  const displaySensitive = !!owner?.role?.permissions.userEdit;
  const userIndexes = getUserIndexes(displaySensitive);

  useEffect(() => {
    (async () => {
      setUsers(list.map((user) => ({
        ...user,
        displayEmail: user.role?.permissions.login ? user.email : null,
        displayAccountName: user.role?.permissions.login ? user.accountName : null,
      })));
    })();
  }, [list]);

  const rows = users.map((user) => [
    <NavLink to={`/member/${user.id}`} css={generalStyle.link}>{convertUserName(user)}</NavLink>,
    user.role?.name,
    ...(displaySensitive
      ? [
        user.salary ? `¥${user.salary.toLocaleString()}` : 'ー',
        user.displayAccountName || 'ー',
        user.displayEmail || 'ー',
      ]
      : []
    ),
  ]);

  return <Layout>
    <BackLink link='/' label='トップ'></BackLink>
    <H2>メンバー一覧</H2>
    <div css={generalStyle.form}>
      <List
        type='user'
        conditions={userConditions}
        indexes={userIndexes}
        rows={rows}
      />
      {enableEdit && (
        <div css={generalStyle.formRow}>
          <NavLink to='/member/create' css={generalStyle.button()}>新規登録</NavLink>
        </div>
      )}
    </div>
  </Layout>;
};

export default MemberList;
